module.exports = __webpack_public_path__ + "static/media/merchant.36e23742.svg";